<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        setOrder: function(order) {

            this.order = order;
            console.log('order 2', this.order, this.order.systemUser);            
            this.data.total = this.order.total;
            
            if(this.order.systemUser && this.order.systemUser._id){
                this.systemUser = this.order.systemUser._id;
                this.getTrucksByUser();
            }

        },
        selectItem: function(item){
            this.data = item; 
        },
        checkClose: function(item){
            return (item.statusOrder.toUpperCase() != 'CLOSED' && item.statusOrder.toUpperCase() != 'PAID' && item.statusOrder.toUpperCase() != 'REJECTED' )
            return null;
        },
        getTrucksByUser: async function(){
            this.trucks = [];
            if(this.systemUser && this.systemUser.length > 0){
                await Request.do(this, 'POST', Request.getDefaultHeader(this),  {truckDriver: this.systemUser, status:'ACTIVE'}, `${Endpoints.trucks.listByType}`,
                (response)=>{//SUCCESS CALLBACK
                    this.trucks = response.results; 
                },
                (error)=>{//ERROR CALLBACK
                    this.titleToast = this.$t('str.msg.toast.advice');
                    this.messageToast = this.$t('str.msg.error.generic');
                    let res = error.response;
                    if (res){
                        this.messageIdToast = res;
                    }
                    $('#toast').modal('show');
                });
            }

        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.close.order.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            this.orderSelected = item;

             setTimeout(async function(){
                this.$('#confirmationClosePart').modal('show');
                }, 100);
        },
        archive: function(response, justifyClose){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                
                Request.do(this, 'POST', Request.getDefaultHeader(this), {justifyClose: justifyClose} , `${Endpoints.orders.close}${this.orderSelected._id}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');
                        $('#confirmationClosePart').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        this.$('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            this.$('#toast').modal('show');
                        }
                        // console.log(JSON.stringify(error));
                });
            }
            else{ $('#confirmationClosePart').modal('toggle');}
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
